/* eslint-disable @typescript-eslint/unbound-method */
import { Container } from 'pixi.js';
import type { LevelData } from 'game/level/LevelData';
import type { Scene } from '../app/SceneManager';
import type { App } from '../app/App';
import { EditorController } from './EditorController';

export interface EditorSceneOptions {
  readonly app: App;
  readonly levelData?: LevelData;
}

export class EditorScene implements Scene {
  public readonly id = 'Editor';

  public readonly view = new Container();

  private readonly editorController: EditorController;

  constructor(options: EditorSceneOptions) {
    this.editorController = new EditorController({
      app: options.app,
      levelData: options.levelData,
      dragContainer: this.view,
      parent: this.view,
    });
  }

  public destroy(): void {
    this.editorController.destroy();
    this.view.destroy({ children: true });
  }

  public update(deltaTime: number): void {
    this.editorController.update(deltaTime);
  }

  public exportLevelData(): LevelData {
    return this.editorController.exportLevelData();
  }

  public restoreState(levelData: LevelData): void {
    this.editorController.restoreState(levelData, true);
  }
}
